<template>
  <div class="loading-indicator loading-indicator--full-page" v-if="isLoading">
    <MoonLoader size="75px" color="#ffffff"></MoonLoader>
    <div class="loadingText">Loading</div>
  </div>
</template>

<script>
  import lodash from 'lodash';
  import { mapGetters } from 'vuex';
  import MoonLoader from 'vue-spinner/src/MoonLoader.vue';

  export default {
    name: 'LoadingIndicator',
    components: {
      MoonLoader,
    },
    computed: {
      ...mapGetters('main', ['memberChangeLoading']),
      loaders() {
        return [
          this.memberChangeLoading,
        ];
      },
      isLoading() {
        return lodash.filter(this.loaders, loader => loader).length > 0;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .loading-indicator {
    @include m(full-page) {
      left: 0;
      z-index: 100;
    }
  }
</style>
